import React from 'react';
import { WatchState } from './watchState/WatchState';
import { WatchControlPanel } from './components/WatchControlPanel/WatchControlPanel';
import { Categories } from './components/Watches/Watches';
import { ModalWindows } from './components/ModalWindows';
import { WatchFullInfoPage } from '../WatchFullInfo';
import style from './index.module.scss';

export const WatchesPage: React.FC = () => {
	return (
		<WatchState>
			<div className={style.container} data-test="WatchesPage">
				<WatchControlPanel />
				<Categories />
				<ModalWindows />
				<WatchFullInfoPage />
			</div>
		</WatchState>
	);
};
